/**
 *
 */
const style = (t) => {
    const { colors, typography } = t['foundations-library']
    const coloring = {}
    for (const c of Object.keys(colors)) {
        const key = `&.infotip--${c}`
        coloring[key] = {
            backgroundColor: colors[c][600]
        }
    }
    return {
        infotip: {
            position: 'relative',
            display: 'block',
            cursor: ({ value }) => value ? 'pointer' : 'inherit'
        },
        popup: {
            ...typography.body3,
            maxWidth: 253,
            borderRadius: '6px',
            padding: '20px',
            color: '#fff',
            textAlign: 'center',
            minWidth: '200px',
            boxSizing: 'border-box',
            wordBreak: 'break-word',
            ...coloring
        }
    }
}

export default style
